module.exports = __webpack_public_path__ + "img/fashion_69.ebe0b9aa.jpg";